import Input from "@8x8/oxygen-input";
import React, { useCallback, useState } from "react";
import { notify, TYPE } from "@8x8/oxygen-toaster";
import {
  MarginLeftButton,
  MarginRightFlexContainer,
} from "@/react/features/smp/licenses/components/styled";

export function RowCountSelector({
  table,
  setRowSelection,
  rowSelection,
  idKey,
}) {
  const [quantityToSelect, setQuantityToSelect] = useState();

  const onSelectClick = useCallback(
    (table) => () => {
      const rowSelection = table
        .getRowModel()
        .rows.filter((row) => row.getCanSelect())
        .slice(0, quantityToSelect)
        .reduce((acc, row) => {
          acc[row.getValue(idKey)] = true;
          return acc;
        }, {});
      if (Object.keys(rowSelection).length === 0) {
        notify({
          type: TYPE.info,
          content: "No rows to select",
          duration: 5000,
        });
        return;
      }
      setRowSelection(rowSelection);
    },
    [quantityToSelect, rowSelection]
  );

  return (
    <MarginRightFlexContainer>
      <Input
        placeholder="Rows to select"
        value={quantityToSelect}
        onChange={(e) => setQuantityToSelect(e.target.valueAsNumber)}
        type="number"
        min={0}
        max={table.getRowModel().rows.length}
      />
      <MarginLeftButton
        variant="tertiary"
        size="small"
        isDisabled={!Boolean(quantityToSelect)}
        onClick={onSelectClick(table)}
      >
        Select
      </MarginLeftButton>
    </MarginRightFlexContainer>
  );
}
